import z from 'zod';

const tokenSchema = z.object({
  accessToken: z.string(),
  refreshToken: z.string()
});

export { tokenSchema };
